import { z } from 'zod';

export const $CandidateStatusCode = z.enum([
  'NEW',
  'LOOKING',
  'EMPLOYED',
  'CONSIDERING',
  'NOT_LOOKING',
]);

export const $CandidateStatus = z.object({
  name: $CandidateStatusCode,
  displayName: z.string(),
});
